import {
  MemreButton,
  MemreContextMenu,
  MemreFlexBox,
  MemreLoading,
  MemreScrollable,
  MemreSortableList,
} from 'components/core';
import * as colours from 'core/colors';
import { useAuthoringContext } from '../AuthoringContext';
import ItemCard from '../ItemCard';
import useMenuItems from './useMenuItems';

export default function AuthorItems() {
  const { reorder, items, isLoadingNewItem, set } = useAuthoringContext();
  const availableItems = useMenuItems(set?.goalType);

  return (
    <MemreFlexBox direction="column">
      <MemreScrollable height="100%">
        <MemreFlexBox
          direction="column"
          gap={2}
          sx={{
            p: 2,
            width: 240,
            height: '100%',
            background: colours.hexToRGB(colours.veryLightGray, 0.5),
            borderRight: `1px solid ${colours.veryLightGray}`,
          }}
        >
          <MemreSortableList
            restrictAxis="y"
            onReorder={reorder}
            items={items}
            render={(item, dragHandle) => (
              <ItemCard
                key={item.id}
                id={item.id}
                title={item.name}
                templateType={item.templateType}
                dragHandle={dragHandle}
                handleClone={() => item.duplicate()}
                isLoadingNewItem={isLoadingNewItem}
                handleDelete={item.delete}
                handleSelect={item.select}
                isSelected={item.selected}
              />
            )}
          />
          {isLoadingNewItem && (
            <MemreFlexBox direction="column" align="center" sx={{ p: 2 }}>
              <MemreLoading />
            </MemreFlexBox>
          )}
          <MemreFlexBox sx={{ pt: 2 }} direction="column">
            <MemreContextMenu
              itemGroups={availableItems}
              triggerElement={
                <MemreButton
                  variant="contained"
                  text="New Item"
                  size="small"
                  iconName="plus"
                  sx={{ width: '100%' }}
                  disabled={isLoadingNewItem}
                />
              }
            />
          </MemreFlexBox>
        </MemreFlexBox>
      </MemreScrollable>
    </MemreFlexBox>
  );
}
